export const generateCategory = (birth_year) => {
  if (birth_year >= 2015) {
    return "Minikler";
  }
  if (birth_year >= 2010) {
    return "Çocuklar";
  }
  if (birth_year >= 2005) {
    return "Gençler";
  }
  if (birth_year >= 1974) {
    return "Yetişkinler";
  }
  if (birth_year <= 1973) {
    return "Emektarlar";
  }
};

// Kargo adresinin açık adres satırı (il/ilçe hariç)
export const formatShippingAddress = (k) =>
  [
    k.mahalle && `${k.mahalle} Mah.`,
    k.sokak,
    k.bina_no && `No: ${k.bina_no}`,
    k.daire_no && `Daire: ${k.daire_no}`,
    k.adres_tarifi,
    k.adres, // eski kayıtlar için
  ]
    .filter(Boolean)
    .join(" ");
